<!-- 广告弹窗 -->
<template>
    <div class="bottom-adv">
        <div class="content">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in advConfig" :key="index">
                    <img :src="item.img | urlFilter" alt="" @click="handleToUrl(item.url)">
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>
<script>
export default {
    name: 'topAdv',
    props: {
        advConfig: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            imgUrl: 'https://files.sciconf.cn/',
        }
    },
    methods: {
        handleToUrl (url) {
            if (url) {
                window.open(url, '_blank')
            }
        }
    },
    created () {
        
    },
    mounted () {
    },
    beforeDestroy () {
        clearInterval(this.timer)
        this.timer = null
    }
}
</script>
<style lang="less" scoped>
/deep/.van-swipe {
    height: 100%;
}
// 移动端
.bottom-adv {
    width: 100%;
    .content {
        width: 100%;
        img {
            width: 100%;
            object-fit: cover;
            object-position: center center;
        }
    }
}
</style>